import React from 'react';
import classnames from 'classnames';
import InfiniteScroll from 'v2/common/InfiniteScroll/InfiniteScroll';
import styles from './RequestsList.module.scss';
import RequestsItem from './RequestsItem';
import { DjangoListResponse, SearchEntity, WithInfiniteQuery } from 'v2/models';

type RequestsListProps = WithInfiniteQuery<DjangoListResponse<SearchEntity>> & {
  selected: SearchEntity | null;
  onSelect: (search: SearchEntity) => void;
};

const RequestsList = ({
  data,
  infiniteQueryFetch,
  selected,
  onSelect,
}: RequestsListProps) => {
  return (
    <>
      <div
        className={classnames(styles.requestsListHeader, styles.columnCount_2)}
      >
        <p>name</p>
        <p>date created</p>
      </div>
      <div
        aria-label="requests-list"
        className={classnames(styles.requestsListContainer)}
      >
        {data.pages.map((page) =>
          page.results.map((request) => {
            return (
              <RequestsItem
                key={request.id}
                request={request}
                onClick={(item) => onSelect(item)}
                isSelected={!!(selected && selected.id === request.id)}
              />
            );
          })
        )}
      </div>
      <InfiniteScroll
        callback={() => infiniteQueryFetch.fetchNextPage()}
        isLoading={infiniteQueryFetch.isFetching}
        disabled={!infiniteQueryFetch.hasNextPage}
        scrollThreshold={500}
      />
    </>
  );
};

export default RequestsList;
